import {
  Component,
  OnInit,
  ViewEncapsulation,
  AfterViewInit,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { Helpers } from "../../../helpers";
import { CookieService } from "ngx-cookie-service";
import { Http, Headers, RequestOptions, Response } from "@angular/http";
import { appService } from "../../../../app/_services/app.service";
import { environment } from "../../../../environments/environment";
import { ToastrService } from "ngx-toastr/";
import { CommonService } from "../../../../app/_services/common.service";
import { DatePipe } from "@angular/common";
import { Router } from "@angular/router";
import { NavService } from "../../../_services/NavService.service";
import { TimelineService } from "../../../_services/timeline.service";
import { TranslateConfigService } from "../../home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
import { DashboardComponent } from '../../pages/default/dashboard/dashboard.component';
import { EncryptPipe, DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Modal } from "@amcharts/amcharts4/core";
// import { taskService } from "src/app/_services/task.service";
const LNG_KEY = "SELECTED_LANGUAGE";
declare var jquery: any;
declare let mLayout: any;
declare var $: any;
declare let mApp: any;
declare var moment: any;

export interface Task {
  id: number;
  tasktitle: string;
  taskdescription: string;
  Taskdateandtime: Date;
  status: string;
}

export class ResetPasswordViewModel {
  public Id: string;
  public Password: string;
  public ConfirmPassword: string;
  public Code: string;

  constructor(
    public _Id: string,
    public _Code: string,
    public _Password: string
  ) {
    this.Id = _Id;
    this.Code = _Code;
    this.Password = _Password;
  }
}

@Component({
  selector: "app-header-nav",
  templateUrl: "./header-nav.component.html",
  encapsulation: ViewEncapsulation.None,
})



export class HeaderNavComponent implements OnInit, AfterViewInit {
  setlang: any = [{ Lang: "", userid: "" }];
  selectedLang: string;
  static headerNavComponent: HeaderNavComponent;
  selectFile: any;
  UserEmailId: any;
  selectedTrip: any;
  EmailId: any;
  UserFullName: any;
  userRole: any;
  userRolesList: any;
  userComanyName: any;
  datatable: any;
  UserProFilePhotoName: any;
  Notification: any;
  User: any = {};
  userCompanyList: any;
  TenantUsers: any;
  TenantId: any;
  CompanyIdForCookie: any;
  DefaultCompany: any;
  userId: any;
  OrderData: any = {};

  selectedCheckbox = true;
  loading = false;
  CompanyId: any;
  userCountCookie: number;
  public userCountCurrent: any;
  public userTypeList: any;
  public NetworkTypeId: any;
  public isDisabled: boolean;
  toggle = false;
  static that: HeaderNavComponent;
  SearchTripNumber: any;
  SearchCustomerSearch: any;
  SearchFromLocation: any;
  SearchToLocation: any;
  SearchVehicleTypes: any;
  SearchVehicleNumber: any;
  //SearchTransporterId: any;
  SearchLRNumber: any;
  DispatchDate: any;
  //  ArrivalDate: any;
  TripSearchData: any = [];
  OrderSearchData: any = [];
  searchTripForm: boolean;
  searchOrderForm: boolean;
  SearchOrderNumber: any;
  SearchReferenceNumber: any;
  searchBillForm: boolean;
  SearchBillNumber: any;
  FromDate: any;
  ToDate: any;
  VendorSearch: any;
  TranspoterId: any;
  VendorId: any;
  BillSearchData: any = [];
  DriverId: any;
  searchPaymentForm: boolean;
  PaymentSearchData: any = [];
  hostURL = environment.apiUrl;
  // hostURL: string = 'https://gatisaar.ifreightbox.net/';

  // added by vithujan
  ConsignmentNote_2 = [1, 2, 3];
  ConsignmentsData: any = [];
  containerNo: any;
  sealNo: any;
  SelectedCompanyCIN: any;
  SelectedCompantGSTIN: any;
  SelectedCompanyPAN: any
  SelectedComapnyName: any;
  SelectedCompanyAdd: any;
  imgPath: any;
  SelectedCompantEmail: any;
  SelectedCompanyWebsite: any;
  SelectedCompanyLogo: any;
  head_trackid: any;
  @ViewChild('print') print: any;
  tripdetaildata: any;
  showModal = false;


  // end
  constructor(
    // private taskService: taskService,
    public datepipe: DatePipe,
    private cookieService: CookieService,
    private _appService: appService,
    private anghttp: Http,
    private toastr: ToastrService,
    private commonService: CommonService,
    private _navService: NavService,
    private chatservice: TimelineService,
    private service: TranslateConfigService,
    private translate: TranslateService,
    public db: DashboardComponent,
    private encryptpipe: EncryptPipe,
    private decryptpipe: DecryptPipe,
    private modalService: NgbModal,
    private router: Router
  ) {
    this.userCountCookie = 0;
    this.userCountCurrent = 0;
    this.isDisabled = false;
    HeaderNavComponent.headerNavComponent = this;
    // setInterval(function () {
    //   HeaderNavComponent.headerNavComponent.GetBeatsNotificationList();
    // }, 900000);

    //Shivang 12-Mar-2021 Translator
    HeaderNavComponent.that = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
    //End
  }


  @Output() CompanyChnage = new EventEmitter<string>();

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.UserEmailId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("EmailId")));
    this.UserFullName = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserFullName")));
    this.userComanyName = JSON.parse(localStorage.getItem("userComanyName"));
    this.EmailId = this.UserEmailId;
    let x = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SetUserRole")));
    var userRole1 = x;
    this.userRole = $.parseJSON(userRole1);
    this.GetUserType();
    this.GetNetworkTypeList("", "");
    this.PutProfilePhoto();
    this.TenantId = JSON.parse(this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    this._appService
      .GetById("User", "GetCompanyList", this.TenantId)
      .subscribe((response) => {
        this.userCompanyList = response;
      });
    this.GetUserCompany();
    this.userCountCookie = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserCount")))
    );
    this.TenantId = JSON.parse(this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    this.User.IsActive = true;
    this._appService
      .GetById("User", "GetRolesList", this.TenantId)
      .subscribe((response) => {
        this.userRolesList = response;
        this.refreshUserRoles();
      });
    HeaderNavComponent.headerNavComponent.refreshUserRoles();
    // this.GetBeatsNotificationList();
    this.selectedLang = localStorage.getItem("SELECTED_LANGUAGE");

    this.GetSelectData();
    this.RefreshvalidDate();
    // added by vithujan
    setTimeout(() => {
      this.GetLoginCompanyData();
    }, 1000);
    // end
  }

  openRaiseTicketModal(){
    this.showModal = true;
  }

  onToggle() {
    this.toggle = !this.toggle;
  }
  private GetUserType() {
    this._appService.Get("User", "GetNetworkType").subscribe((response) => {
      this.userTypeList = response;
      HeaderNavComponent.headerNavComponent.refreshUserRoles();
    });
  }

  languageChanged() {
    const data: any = [];
    this.setlang[0].Lang = this.selectedLang;
    this.setlang[0].userid = this.userId;
    this._appService
      .PostFunc("Signup", "SetDefaultLangugeForUsers", this.setlang)
      .subscribe(
        (res) => {
          this.toastr.success("Language successfuly changed", "Success");
          this.db.translate.setDefaultLang(this.setlang);
          this.db.selectedLang = this.setlang;
          this.service.setLanguage(this.selectedLang);
          this.db.reload();
        },
        (err) => {
          this.toastr.warning(
            "Something went wrong while changing language",
            "Warning"
          );
        }
      );
  }

  SetDefaultLangForUser(lang: any) { }

  private GetNetworkTypeList(routeAction: string, userType: string) {
    $("#SelectNetworkListHeader").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url:
          routeAction !== undefined
            ? environment.apiUrl + routeAction
            : routeAction, //"api/User/GetNetworkList",
        headers: {
          "Authorization": HeaderNavComponent.headerNavComponent._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
            userType: userType, //'Supplier' / 'Carrier' / 'Customer'
            TenantId: HeaderNavComponent.headerNavComponent.TenantId,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search for Network",
    });
  }

  public OnUserTypeChange(userTypeId) {
    var userTypeName = "";
    this.userTypeList.forEach((element) => {
      if (element.Id == userTypeId) {
        return (userTypeName = element.Label);
      }
    });
    this.isDisabled = false;
    if (userTypeName == "Supplier") {
      HeaderNavComponent.headerNavComponent.FillMultiSelectedList(
        "#SelectNetworkListHeader",
        []
      );
      this.GetNetworkTypeList("api/User/GetNetworkListByUserType", "supplier");
    } else if (userTypeName == "Customer") {
      HeaderNavComponent.headerNavComponent.FillMultiSelectedList(
        "#SelectNetworkListHeader",
        []
      );
      this.GetNetworkTypeList(
        "api/User/GetNetworkListByUserType",
        "Manufacturer"
      );
    } else if (userTypeName == "Carrier") {
      HeaderNavComponent.headerNavComponent.FillMultiSelectedList(
        "#SelectNetworkListHeader",
        []
      );
      this.GetNetworkTypeList(
        "api/User/GetNetworkListByUserType",
        "Transporter"
      );
    } else if (userTypeName == "Employee") {
      HeaderNavComponent.headerNavComponent.FillMultiSelectedList(
        "#SelectNetworkListHeader",
        []
      );
      this.isDisabled = true;
    } else if (userTypeName == "") {
      HeaderNavComponent.headerNavComponent.FillMultiSelectedList(
        "#SelectNetworkListHeader",
        []
      );
      this.isDisabled = true;
    }
  }

  /**
   * Usage: we can fill or reset multiselect list
   * @param selectorId : multiselector Id
   * @param id : field Id
   * @param name : field name
   */
  public FillMultiSelectedList(selectorId, data: any[]) {
    let networkSelector = $(selectorId);
    var Options: any = [];
    $.each(data, function (i) {
      Options.push(
        '<option value="' +
        data[i].NetworkTypeId +
        '" selected>' +
        data[i].NetworkTypeName +
        "</option>"
      );
    });
    networkSelector.html(Options);
  }

  ngAfterViewInit() {
    //  mLayout.initHeader();
    // this.GetSelectDataOfTransporter();
  }

  onCloseUserModel = function () {
    this.User = {};
    HeaderNavComponent.headerNavComponent.refreshUserRoles();
    HeaderNavComponent.headerNavComponent.OnUserTypeChange("");
    HeaderNavComponent.headerNavComponent.ClearMultiSelector();
    HeaderNavComponent.headerNavComponent.ClearValidations();
    this.User.AllowedCompanyIds = [];
    HeaderNavComponent.headerNavComponent.userCompanyList.forEach((company) => {
      company.selected = false;
    });
    HeaderNavComponent.headerNavComponent.User.IsActive = true;
  };

  refreshUserRoles() {
    setTimeout(function () {
      (<any>$("#userRolesHeader")).selectpicker("refresh");
      (<any>$("#userTypeIdHeader")).selectpicker("refresh");
    });
  }

  ChnageDefultCompany() {
    localStorage.setItem("ChnageCompnayId", JSON.stringify(this.CompanyIdForCookie));
    this.CompanyChnage.emit(this.CompanyIdForCookie);
    this._navService.changeNav(this.CompanyIdForCookie);
    console.log(this.CompanyIdForCookie, 'this.CompanyIdForCookie')
  }

  SaveUser() {
    mApp.block("#UserFormBodyHeader", {});
    Helpers.setLoading(true);
    let flag = false;
    let CompanyIds = [];

    if (!this.ValidateUser()) {
      mApp.unblock("#UserFormBodyHeader", {});
      return false;
    }
    this.userCompanyList.forEach((element) => {
      if (element.selected == true) {
        CompanyIds.push(element.Id);
      }
    });
    CompanyIds.forEach((element) => {
      if (element == this.User.DefaultCompanyId) {
        flag = true;
      }
    });
    if (flag == false) {
      this.toastr.warning(
        "Default company must be within Allowed Company List.",
        "error"
      );
      mApp.unblock("#UserFormBodyHeader", {});
      return false;
    }
    this.User.NetworkTypeIdList = [];
    this.User.AllowedCompanyIds = CompanyIds;
    this.User.TenantId = this.TenantId;

    var selecteNetwork1 = $("#SelectNetworkListHeader").val();
    this.User.NetworkTypeIdList = [];
    if (selecteNetwork1 !== null) {
      selecteNetwork1.forEach((element) => {
        this.User.NetworkTypeIdList.push(element);
      });
    }
    this._appService.Post("User", "SaveUser", this.User).subscribe(
      (response) => {
        mApp.unblock("#UserFormBodyHeader", {});
        this.toastr.success("User data saved successfully !", "Success");
        $("#newUserHeader").modal("hide");
        $("#SelectNetworkListHeader").val("");
        this.onCloseUserModel();
        HeaderNavComponent.headerNavComponent.ClearValidations();
        this.User.NetworkTypeIdList = [];
        HeaderNavComponent.headerNavComponent.ClearMultiSelector();
        HeaderNavComponent.headerNavComponent.datatable.reload();
      },
      (err) => {
        mApp.unblock("#UserFormBodyHeader", {});
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
    Helpers.setLoading(false);
  }

  private ClearMultiSelector() {
    $("#SelectNetworkListHeader").val("");
  }

  GetAllIsActiveUserCount() {
    this._appService
      .Get("User", "GetAllIsActiveUserCount")
      .subscribe((response) => {
        this.userCountCurrent = response;
      });
  }

  OnProfilePhotoClick() {
    $("#ProfilePhotoHeader").trigger("click");
  }

  ProfilePhotoClick(event) {
    this.selectFile = event.target.files[0];
    if (
      this.selectFile == undefined ||
      this.selectFile == "" ||
      this.selectFile == null
    ) {
      this.toastr.error("Please select file to upload", "error");
      return false;
    }
    var fd = new FormData();
    if (fd.has("file")) {
      fd.set("file", this.selectFile);
    } else {
      fd.append("file", this.selectFile);
    }
    var headers = new Headers();
    let SetUserRole = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SetUserRole")));
    let user_access_token = this.decryptpipe.transform(JSON.parse(this.cookieService.get("user_access_token")));
    const token: string = "Bearer " + user_access_token;
    headers.append("Authorization", token);
    let options = new RequestOptions({ headers: headers });
    const apiUrl =
      environment.apiUrl + "/api/User/UploadProfilePhoto?id=" + SetUserRole;

    // added by vithujan 01-11-2022
    var current_url = window.location.href;
    var url_object = new URL(current_url);
    var domain = url_object.hostname;
    //end

    const req1 = this.anghttp.post(apiUrl, fd, options).subscribe(
      (response) => {
        let NewPic: string = JSON.parse(response["_body"]);
        this.cookieService.set("ProfilePhotoName", JSON.stringify(this.encryptpipe.transform(NewPic)), undefined, undefined, undefined, environment.apiUrl == 'http://tms.theptpl.com/' ? false : true);
        this.PutProfilePhoto();
        this.toastr.success("Successfully Updated !", "success");
      },
      (err) => {
        this.toastr.error("Error occured while Uploading...", "error");
      }
    );
  }

  PutProfilePhoto() {
    // this.UserProFilePhotoName = $.parseJSON(this.cookieService.get("ProfilePhotoName"));
    this.UserProFilePhotoName = this.decryptpipe.transform(JSON.parse(this.cookieService.get("ProfilePhotoName")));
  }

  GetNotification() {
    this._appService
      .GetById("Roles", "GetNotification", this.TenantId)
      .subscribe(
        (response) => {
          this.Notification = response;
        },
        (err) => {
          console.log("Error occured");
        }
      );
  }

  GetUserById() {
    this._appService.GetById("User", "GetUser", this.userId).subscribe(
      (response) => {
        var networkSelector = $("#SelectNetworkListHeader");
        if (response != false) {
          HeaderNavComponent.headerNavComponent.User = response;
          HeaderNavComponent.headerNavComponent.refreshUserRoles();
          HeaderNavComponent.headerNavComponent.ClearMultiSelector();
          if (response.networkTypeList != null) {
            HeaderNavComponent.headerNavComponent.OnUserTypeChange(
              response.UserTypeId
            );
            var Options: any = [];
            $.each(response.networkTypeList, function (i) {
              Options.push(
                '<option value="' +
                response.networkTypeList[i].NetworkTypeId +
                '" selected>' +
                response.networkTypeList[i].NetworkTypeName +
                "</option>"
              );
            });
            networkSelector.html(Options);
          } else {
            var Options: any = [];
            Options += '<option value=""></option>';
            networkSelector.html(Options);
            networkSelector.val("").change();
          }
          HeaderNavComponent.headerNavComponent.ClearValidations();
          HeaderNavComponent.headerNavComponent.userCompanyList.forEach(
            (company) => {
              if (
                HeaderNavComponent.headerNavComponent.User.AllowedCompanyIds.indexOf(
                  company.Id
                ) !== -1
              ) {
                company.selected = true;
              } else {
                company.selected = false;
              }
            }
          );
        }
        $("#newUserHeader").modal("show");
      },
      (err) => {
        this.toastr.error("Error occured while getting data...");
      }
    );
  }

  GetUserCompany() {
    this._appService.GetById("Company", "GetUserCompany", this.TenantId).subscribe((response) => {
      this.TenantUsers = response.data; //FOR DROPDOWN

      this.TenantUsers.forEach((element) => {
        if (element.DefaultCompanyId == element.Id) {
          this.CompanyIdForCookie = element;
          $("#UserCompany").val(element.Id);
        }
      });

      if (localStorage.getItem("ChnageCompnayId") == "undefined") {
        localStorage.setItem("ChnageCompnayId", JSON.stringify(this.CompanyIdForCookie));
      }

      if (
        JSON.parse(localStorage.getItem("ChnageCompnayId")) == null &&
        JSON.parse(localStorage.getItem("ChnageCompnayId")) == undefined
      ) {
        localStorage.setItem("ChnageCompnayId", JSON.stringify(this.CompanyIdForCookie));
      } else {
        this.TenantUsers.forEach((element) => {
          if (JSON.parse(localStorage.getItem("ChnageCompnayId")).Id != undefined) {
            if (JSON.parse(localStorage.getItem("ChnageCompnayId")).Id == element.Id) {
              this.CompanyIdForCookie = element;
            }
          }
        });
      }
      this.ChnageDefultCompany();
    },
      (err) => {
        console.log("Error occured");
      }
    );
  }

  ValidateUser = function () {
    this.ClearValidations();
    var flag = true;
    if (
      !HeaderNavComponent.headerNavComponent.commonService.ValidateRequiredField(
        $("#FirstNameHeader"),
        "Please Enter First Name",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !HeaderNavComponent.headerNavComponent.commonService.ValidateRequiredField(
        $("#LastNameHeader"),
        "Please Enter Last Name",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !HeaderNavComponent.headerNavComponent.commonService.ValidateRequiredField2(
        $("#userRolesHeader"),
        $("#FieldSetRolesHeader"),
        "Please Select Roles",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !HeaderNavComponent.headerNavComponent.commonService.ValidateRequiredField(
        $("#MobileNoHeader"),
        "Please Enter Mobile No.",
        "after",
        ""
      )
    ) {
      flag = false;
    } else {
      if (
        !HeaderNavComponent.headerNavComponent.commonService.CheckPhoneNumber(
          $("#MobileNoHeader"),
          "after"
        )
      ) {
        flag = false;
      }
    }
    if (
      !HeaderNavComponent.headerNavComponent.commonService.ValidateRequiredField(
        $("#EmailHeader"),
        "Please Enter Email",
        "after",
        ""
      )
    ) {
      flag = false;
    } else {
      if (
        !HeaderNavComponent.headerNavComponent.commonService.CheckEmail(
          $("#EmailHeader"),
          "after"
        )
      ) {
        flag = false;
      }
    }
    if (
      !HeaderNavComponent.headerNavComponent.commonService.ValidateRequiredField2(
        $("#userTypeIdHeader"),
        $("#FieldSetuserTypeIdHeader"),
        "Please select user type",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    /** If User Type is not Employee, validation not require */
    if (!this.isDisabled) {
      if (
        !HeaderNavComponent.headerNavComponent.commonService.ValidateRequiredField2(
          $("#SelectNetworkListHeader"),
          $("#FieldsetNetworkListHeader"),
          "Please Enter Name",
          "after",
          ""
        )
      ) {
        flag = false;
      }
    }
    return flag;
  };

  ClearValidations = function () {
    HeaderNavComponent.headerNavComponent.commonService.ClearMessage(
      $("#FirstNameHeader")
    );
    HeaderNavComponent.headerNavComponent.commonService.ClearMessage(
      $("#LastNameHeader")
    );
    HeaderNavComponent.headerNavComponent.commonService.ClearMessage(
      $("#userRolesHeader")
    );
    HeaderNavComponent.headerNavComponent.commonService.ClearMessage(
      $("#MobileNoHeader")
    );
    HeaderNavComponent.headerNavComponent.commonService.ClearMessage(
      $("#EmailHeader")
    );
    HeaderNavComponent.headerNavComponent.commonService.ClearMessage(
      $("#userTypeIdHeader")
    );
    HeaderNavComponent.headerNavComponent.commonService.ClearMessage(
      $("#SelectNetworkListHeader")
    );
    HeaderNavComponent.headerNavComponent.commonService.ClearMessage(
      $("#FieldsetNetworkListHeader")
    );
  };

  //Getting SharePoint list
  GetBeatsNotificationList() {
    this._appService
      .GetByTwoId(
        "Beats",
        "GetListOfUserNotification",
        this.TenantId,
        this.userId
      )
      .subscribe(
        (response) => {
          this.Notification = [];
          response.map((o) => {
            this.Notification = o.totalBeatsNotification;
          });
        },
        (err) => {
          // this.toastr.error("Error occurred while fetching Data !", 'error');
        }
      );
  }

  // GetSelectDataOfTransporter() {
  //   $(".TransporterSearchHeader").each(function () {
  //     $(this).select2({
  //       tags: false,
  //       width: "100%",
  //       escapeMarkup: function (markup) {
  //         return markup;
  //       },
  //       minimumInputLength: 2,
  //       ajax: {
  //         global: false,
  //         url: environment.apiUrl + "api/Booking/GetTransporterSelectList",
  //         delay: 300,
  //         dataType: "json",
  //         allowClear: true,
  //         data: function (params) {
  //           return {
  //             query: params.term,
  //             page: params.page || 1,
  //             TenantId: HeaderNavComponent.that.TenantId,
  //           };
  //         },
  //         processResults: function (data, params) {
  //           params.page = params.page || 1;
  //           return {
  //             results: data.Results,
  //             pagination: {
  //               more: params.page * 30 < data.Total,
  //             },
  //           };
  //         },
  //       },
  //       tokenSeparators: [","],
  //       createTag: function (params) {
  //         var term = $.trim(params.term);
  //         if (validateVehicle(term)) {
  //           return {
  //             id: term,
  //             text: term.toUpperCase(),
  //             newTag: true,
  //           };
  //         }
  //         HeaderNavComponent.that.toastr.error(
  //           "Special Characters are not allowed !",
  //           "Error"
  //         );
  //         return null;
  //         function validateVehicle(no) {
  //           var re = /^[a-zA-Z0-9 ]*$/;
  //           return re.test(no);
  //         }
  //       },
  //       insertTag: function (data, tag) {
  //         data.push(tag);
  //       },
  //       placeholder: "Enter Transporter Name",
  //     });
  //   });
  //   $(".TransporterSearchHeader").on("select2:select", function (e) {
  //     var data = e.params.data;
  //     console.log(data);
  //     HeaderNavComponent.headerNavComponent.SearchTransporterId = data.id;
  //   });
  // }


  GetSelectData() {
    $(".CustomerSearchHeader").select2({
      tags: true,
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/ManualvehiclePlanning/GetCustomerdata",
        headers: {
          "Authorization": HeaderNavComponent.headerNavComponent._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
            TenantId: HeaderNavComponent.that.TenantId,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [","],
      createTag: function (params) {
        $(".select2-search__field").keydown(function (e) {
          if (e.keyCode != 32) {
            var term = $.trim(params.term);
            // Don't offset to create a tag if there is no valid email
            return {
              id: term,
              text: term,
              newTag: true, // add additional parameters
            };
          }
        });
      },
      insertTag: function (data, tag) {
        data.push(tag);
      },
      placeholder: "  Enter Customer Name",
    });

    $(".CustomerSearchHeader").on("select2:select", function (e) {
      var data = e.params.data;
      let index = e.target.id.split("_")[1];
      //  HeaderNavComponent.headerNavComponent.OrderData.CustomerId =
      //   data.id;
      HeaderNavComponent.headerNavComponent.SearchCustomerSearch = data.id;
    });

    $(".VehicleTypeSearchHeader").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url:
          environment.apiUrl +
          "api/ManualvehiclePlanning/GetSelect2VehicleData",
        headers: {
          "Authorization": HeaderNavComponent.headerNavComponent._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "  Search for Vehicle",
    });

    $(".VehicleTypeSearchHeader").on("select2:select", function (e) {
      var data = e.params.data;
      HeaderNavComponent.headerNavComponent.SearchVehicleTypes = data.text;
    });

    $(".VehicleNoSearchHeader").select2({
      width: "100%",
      escapeMarkup: function (markup) { return markup; },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Expense/GetVehicleList",
        headers: {
          "Authorization": HeaderNavComponent.headerNavComponent._appService.getAuthToken(),
        },
        delay: 300,
        dataType: 'json',
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: (params.page * 30) < data.Total
            }
          };
        },
      },
      tokenSeparators: [',', ' '],

      placeholder: 'Enter Vehicle No'
    });

    $(".VehicleNoSearchHeader").on("select2:select", function (e) {
      var data = e.params.data;
      HeaderNavComponent.headerNavComponent.SearchVehicleNumber = data.text;
    });

    $(".FromSearchHeader").select2({
      tags: true,
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/OrdersByVehicle/GetLocationCode",
        headers: {
          "Authorization": HeaderNavComponent.headerNavComponent._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          //$("#PickUpLocationCode1").text('');
          return {
            query: params.term,
            page: params.page || 1,
            Type: 1,
            CustomerId:
              HeaderNavComponent.headerNavComponent.OrderData
                .CustomerId == undefined
                ? null
                : HeaderNavComponent.headerNavComponent.OrderData
                  .CustomerId, //ByVehicleEntryComponent.byVehicleEntryComponent.OrderData.CustomerId
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Enter Origin Location",
    });

    $(".FromSearchHeader").on("select2:select", function (e) {
      var data = e.params.data;
      HeaderNavComponent.headerNavComponent.SearchFromLocation = data.text;
    });

    $(".ToSearchHeader").select2({
      tags: true,
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/OrdersByVehicle/GetLocationCode",
        headers: {
          "Authorization": HeaderNavComponent.headerNavComponent._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          //$("#PickUpLocationCode1").text('');
          return {
            query: params.term,
            page: params.page || 1,
            Type: 1,
            CustomerId:
              HeaderNavComponent.headerNavComponent.OrderData
                .CustomerId == undefined
                ? null
                : HeaderNavComponent.headerNavComponent.OrderData
                  .CustomerId, //ByVehicleEntryComponent.byVehicleEntryComponent.OrderData.CustomerId
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Enter Destination Location",
    });

    $(".ToSearchHeader").on("select2:select", function (e) {
      var data = e.params.data;
      HeaderNavComponent.headerNavComponent.SearchToLocation = data.text;
    });

    $(".VendorSearchHeader").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Bills/GetVendorName",
        headers: {
          "Authorization": HeaderNavComponent.headerNavComponent._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          $("#VendorSearchHeader").text("");
          return {
            query: params.term,
            page: params.page || 1,
            TenantId: HeaderNavComponent.that.TenantId,
            Type: "Bills",
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [","],

      placeholder: "Search for Vendor",
    });

    // $(".VendorSearchHeader").on("select2:select", function (e) {
    //   var data = e.params.data;
    //   console.log(data);
    //   HeaderNavComponent.headerNavComponent.VendorSearch = data.text;
    // });

    $(".VendorSearchHeader").on("select2:select", function (e) {
      var data = e.params.data;
      HeaderNavComponent.headerNavComponent.VendorSearch = data.text;
      HeaderNavComponent.that.TranspoterId = data.TranspoterId;
      HeaderNavComponent.that.VendorId = data.id;
    });

    $(".DriverSearchHeader").each(function () {
      var Noobj = this;
      setTimeout(function () {
        $(Noobj).select2({
          tags:
            $(Noobj).closest("tr").find(".ClsTransporterType").val() == "Hired",
          width: "100%",
          escapeMarkup: function (markup) {
            return markup;
          },
          minimumInputLength: 2,
          ajax: {
            global: false,
            url: environment.apiUrl + "api/OperationalReport/DriverListBills",
            headers: {
              "Authorization": HeaderNavComponent.headerNavComponent._appService.getAuthToken(),
            },
            delay: 300,
            dataType: "json",
            allowClear: true,
            data: function (params) {
              return {
                query: params.term,
                page: params.page || 1
              };
            },
            processResults: function (data, params) {
              params.page = params.page || 1;
              return {
                results: data.Results,
                pagination: {
                  more: params.page * 30 < data.Total,
                },
              };
            },
          },
          tokenSeparators: [","],
          createTag: function (params) {
            var term = $.trim(params.term);
            return {
              id: term,
              text: term,
              newTag: true,
            };
          },
          insertTag: function (data, tag) {
            data.push(tag);
          },

          placeholder: "Enter Driver Name",
        });
      }, 500);
    });

    $(".DriverSearchHeader").on("select2:select", function (e) {
      var data = e.params.data;
      HeaderNavComponent.headerNavComponent.DriverId = data.DriverId;
    });

  }


  ClearData() {
    $("#DispatchDateHeader").val("");
    $("#ArrivalDateHeader").val("");
    this.DispatchDate = Date.now();
    // this.ArrivalDate = Date.now();
    this.FromDate = Date.now();
    this.ToDate = Date.now();
    this.SearchTripNumber = "";
    this.SearchCustomerSearch = "";
    $(".CustomerSearchHeader").val("");
    $('.CustomerSearchHeader').select2('destroy');
    this.SearchFromLocation = "";
    $(".FromSearchHeader").val("");
    $('.FromSearchHeader').select2('destroy');
    this.SearchToLocation = "";
    $(".ToSearchHeader").val("");
    $('.ToSearchHeader').select2('destroy');
    this.SearchVehicleTypes = "";
    $(".VehicleTypeSearchHeader").val("");
    $('.VehicleTypeSearchHeader').select2('destroy');
    this.SearchVehicleNumber = "";
    $(".VehicleNoSearchHeader").val("");
    $('.VehicleNoSearchHeader').select2('destroy');
    //this.SearchTransporterId = "";
    // $(".TransporterSearchHeader").val("");
    // $('.TransporterSearchHeader').select2('destroy');
    this.VendorSearch = "";
    $(".VendorSearchHeader").val("");
    $('.VendorSearchHeader').select2('destroy');
    this.DriverId = "";
    $(".DriverSearchHeader").val("");
    $('.DriverSearchHeader').select2('destroy');
    this.SearchOrderNumber = "";
    this.SearchReferenceNumber = "";
    this.SearchBillNumber = "";
    //add trupti 16-feb-2022
    this.SearchLRNumber = "";
    //end

    //this.GetSelectDataOfTransporter();
    this.GetSelectData();
  }

  GetFormattedDate(Id, ScopeValue) {
    if (
      moment($("#" + Id).datepicker("getDate")).format("YYYY-MM-DD") !=
      "Invalid date"
    ) {
      ScopeValue = moment($("#" + Id).datepicker("getDate")).format(
        "YYYY-MM-DD"
      );
    } else {
      var date = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
      if (date.test(ScopeValue)) {
        var d = new Date(ScopeValue.split("/").reverse().join("-"));
        ScopeValue = this.datepipe.transform(d, "yyyy-MM-dd");
      }
    }
    return ScopeValue;
  }

  RefreshvalidDate() {
    setTimeout(() => {
      $(".datepicker2").datepicker({
        todayHighlight: !0,
        orientation: "auto",
        autoclose: true,
        format: "dd-M-yyyy",
        setDate: new Date(),
        templates: {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>',
        },
      });
    }, 200);
  }


  // Start: 5-March-2021 Shivang added here
  //-------------------------------------Trip Search-----------------------------------------

  SearchTrip() {
    $("#tripadvancesearch").modal("show");
    this.searchTripForm = true;
  }
  //End: 5-March-2021 Shivang added here

  //Start: 15-Mar-2021 Shivang added her
  GetTripReport() {
    if ($("#TripnoSearchHeader").val() != "" && $("#TripnoSearchHeader").val() != undefined)
      this.SearchTripNumber = $("#TripnoSearchHeader").val();

    if ($("#DispatchDateHeader").val() != "" && $("#DispatchDateHeader").val() != undefined)
      this.DispatchDate = this.GetFormattedDate("DispatchDateHeader", this.DispatchDate);

    // if ($("#ArrivalDateHeader").val() != "" && $("#ArrivalDateHeader").val() != undefined)
    //   this.ArrivalDate = this.GetFormattedDate("ArrivalDateHeader", this.ArrivalDate);

    this._appService.GetBySevenId(
      "OperationalReport",
      "TripSearchReport",
      this.SearchTripNumber == undefined ? "" : this.SearchTripNumber,
      this.SearchCustomerSearch == undefined ? "" : this.SearchCustomerSearch,
      this.DispatchDate == undefined ? "" : this.DispatchDate,
      //  this.ArrivalDate == undefined ? "" : this.ArrivalDate,
      this.SearchFromLocation == undefined ? "" : this.SearchFromLocation,
      this.SearchToLocation == undefined ? "" : this.SearchToLocation,
      //  this.SearchVehicleTypes==undefined?"":this.SearchVehicleTypes, 
      this.SearchVehicleNumber == undefined ? "" : this.SearchVehicleNumber,
      this.SearchLRNumber == undefined ? "" : this.SearchLRNumber,
      // this.SearchTransporterId == undefined ? "" : this.SearchTransporterId
    ).subscribe(response => {
      this.TripSearchData = response;
      //this.ClearData();
    }, err => {
      this.toastr.error("Error occurred while fetching Status data !", 'error');
    });
    //End
  }

  //Start: Shivang 12-Mar-2021 Added Search of fields
  SearchTripReport() {
    this.GetTripReport();
  }
  //End Shivang 12-Mar-2021

  //Start: Shivang 5-Apr-2021 Download Search of trip
  OnDownloadTripSearch() {
    if (this.TripSearchData.length > 0) {
      if ($("#TripnoSearchHeader").val() != "" && $("#TripnoSearchHeader").val() != undefined)
        this.SearchTripNumber = $("#TripnoSearchHeader").val();

      if ($("#DispatchDateHeader").val() != "" && $("#DispatchDateHeader").val() != undefined)
        this.DispatchDate = this.GetFormattedDate("DispatchDateHeader", this.DispatchDate);

      // if ($("#ArrivalDateHeader").val() != "" && $("#ArrivalDateHeader").val() != undefined)
      //   this.ArrivalDate = this.GetFormattedDate("ArrivalDateHeader", this.ArrivalDate);

      this._appService.GetBySevenId(
        "OperationalReport",
        "TripSearchReportDownload",
        this.SearchTripNumber == undefined ? "" : this.SearchTripNumber,
        this.SearchCustomerSearch == undefined ? "" : this.SearchCustomerSearch,
        this.DispatchDate == undefined ? "" : this.DispatchDate,
        //  this.ArrivalDate == undefined ? "" : this.ArrivalDate,
        this.SearchFromLocation == undefined ? "" : this.SearchFromLocation,
        this.SearchToLocation == undefined ? "" : this.SearchToLocation,
        //  this.SearchVehicleTypes == undefined ? "" : this.SearchVehicleTypes,
        this.SearchVehicleNumber == undefined ? "" : this.SearchVehicleNumber,
        this.SearchLRNumber == undefined ? "" : this.SearchLRNumber,
        //   this.SearchTransporterId == undefined ? "" : this.SearchTransporterId
      ).subscribe(response => {
        this.DownloadTripFile(response);
      })
    }
    else {
      this.toastr.error("Data not Avaliable");
    }
  }

  DownloadTripFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTripSearch").attr('href', url);
    $("#DownLoadFileTripSearch").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTripSearch") as HTMLElement;
    element.attributes
    element.click();
    //End 5-Apr-2021
  }
  //End: Shivang 5-Apr-2021

  // -------------------------------------Order Search--------------------------------------------

  //Start: Shivang 7-Apr-2021
  SearchOrder() {
    $("#orderadvancesearch").modal("show");
    this.searchOrderForm = true;
  }

  GetOrderReport() {

    if ($("#OrdernoSearchHeader").val() != "" && $("#OrdernoSearchHeader").val() != undefined)
      this.SearchOrderNumber = $("#OrdernoSearchHeader").val();

    if ($("#ReferenceNoSearchHeader").val() != "" && $("#ReferenceNoSearchHeader").val() != undefined)
      this.SearchReferenceNumber = $("#ReferenceNoSearchHeader").val();

    this._appService.GetByThreeId(
      "OperationalReport",
      "OrderSearchReport",
      this.SearchOrderNumber == undefined ? "" : this.SearchOrderNumber,
      this.SearchReferenceNumber == undefined ? "" : this.SearchReferenceNumber,
      this.SearchCustomerSearch == undefined ? "" : this.SearchCustomerSearch,
    ).subscribe(response => {
      this.OrderSearchData = response;
      this.ClearData();
    }, err => {
      this.toastr.error("Error occurred while fetching Status data !", 'error');
    });
  }

  SearchOrderReport() {
    this.GetOrderReport();
  }

  OnDownloadOrderSearch() {
    if (this.OrderSearchData.length > 0) {
      if ($("#OrdernoSearchHeader").val() != "" && $("#OrdernoSearchHeader").val() != undefined)
        this.SearchOrderNumber = $("#OrdernoSearchHeader").val();

      if ($("#ReferenceNoSearchHeader").val() != "" && $("#ReferenceNoSearchHeader").val() != undefined)
        this.SearchReferenceNumber = $("#ReferenceNoSearchHeader").val()

      this._appService.GetByThreeId(
        "OperationalReport",
        "OrderSearchReportDownload",
        this.SearchOrderNumber == undefined ? "" : this.SearchOrderNumber,
        this.SearchReferenceNumber == undefined ? "" : this.SearchReferenceNumber,
        this.SearchCustomerSearch == undefined ? "" : this.SearchCustomerSearch,
      ).subscribe(response => {
        this.DownloadOrderFile(response);
      })
    }
    else {
      this.toastr.error("Data not Avaliable");
    }
  }

  DownloadOrderFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileOrderSearch").attr('href', url);
    $("#DownLoadFileOrderSearch").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileOrderSearch") as HTMLElement;
    element.attributes
    element.click();
    //End 5-Apr-2021
  }
  //End

  //---------------------------------------------Bill Search---------------------------------

  //Start: Shivang 20-Apr-2021 Bills Search section

  SearchBills() {
    $("#billsadvancesearch").modal("show");
    this.searchBillForm = true;
  }

  GetBillsReport() {

    if ($("BillnoSearchHeader").val() != "" && $("#BillnoSearchHeader").val() != undefined)
      this.SearchBillNumber = $("#BillnoSearchHeader").val();

    if ($("#ReferenceNoSearchHeader").val() != "" && $("#ReferenceNoSearchHeader").val() != undefined)
      this.SearchReferenceNumber = $("#ReferenceNoSearchHeader").val();

    if ($("#FromDateHeaderBill").val() != "" && $("#FromDateHeaderBill").val() != undefined)
      this.FromDate = this.GetFormattedDate("FromDateHeaderBill", this.FromDate);

    if ($("#ToDateHeaderBill").val() != "" && $("#ToDateHeaderBill").val() != undefined)
      this.ToDate = this.GetFormattedDate("ToDateHeaderBill", this.ToDate);

    this._appService.GetBySixId(
      "OperationalReport",
      "BillsSearchReport",
      this.SearchBillNumber == undefined ? "" : this.SearchBillNumber,
      this.SearchReferenceNumber == undefined ? "" : this.SearchReferenceNumber,
      this.FromDate == undefined ? "" : this.FromDate,
      this.ToDate == undefined ? "" : this.ToDate,
      this.VendorSearch == undefined ? "" : this.VendorSearch,
      this.DriverId == undefined ? "" : this.DriverId
    ).subscribe(response => {
      this.BillSearchData = response;
      this.ClearData();
    }, err => {
      this.toastr.error("Error occurred while fetching Status data !", 'error');
    });
  }

  SearchBillsReport() {
    this.GetBillsReport();
  }

  OnDownloadBillsSearch() {
    if (this.BillSearchData.length > 0) {
      if ($("BillnoSearchHeader").val() != "" && $("#BillnoSearchHeader").val() != undefined)
        this.SearchBillNumber = $("#BillnoSearchHeader").val();

      if ($("#ReferenceNoSearchHeader").val() != "" && $("#ReferenceNoSearchHeader").val() != undefined)
        this.SearchReferenceNumber = $("#ReferenceNoSearchHeader").val();

      if ($("#FromDateHeaderBill").val() != "" && $("#FromDateHeaderBill").val() != undefined)
        this.FromDate = this.GetFormattedDate("FromDateHeaderBill", this.FromDate);

      if ($("#ToDateHeaderBill").val() != "" && $("#ToDateHeaderBill").val() != undefined)
        this.ToDate = this.GetFormattedDate("ToDateHeaderBill", this.ToDate);

      this._appService.GetBySixId(
        "OperationalReport",
        "BillsSearchReportDownload",
        this.SearchBillNumber == undefined ? "" : this.SearchBillNumber,
        this.SearchReferenceNumber == undefined ? "" : this.SearchReferenceNumber,
        this.FromDate == undefined ? "" : this.FromDate,
        this.ToDate == undefined ? "" : this.ToDate,
        this.VendorSearch == undefined ? "" : this.VendorSearch,
        this.DriverId == undefined ? "" : this.DriverId
      ).subscribe(response => {
        this.DownloadBillsFile(response);
      })
    }
    else {
      this.toastr.error("Data not Avaliable");
    }
  }

  DownloadBillsFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileBillsSearch").attr('href', url);
    $("#DownLoadFileBillsSearch").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileBillsSearch") as HTMLElement;
    element.attributes
    element.click();
    //End 5-Apr-2021
  }
  //End

  //-------------------------------------------Payments Search----------------------------------

  //Start: Shivang 20-Apr-2021 Payments Search section
  SearchPayment() {
    $("#paymentadvancesearch").modal("show");
    this.searchPaymentForm = true;
  }

  GetPaymentReport() {

    if ($("BillnoSearchHeader").val() != "" && $("#BillnoSearchHeader").val() != undefined)
      this.SearchBillNumber = $("#BillnoSearchHeader").val();

    if ($("#ReferenceNoSearchHeader").val() != "" && $("#ReferenceNoSearchHeader").val() != undefined)
      this.SearchReferenceNumber = $("#ReferenceNoSearchHeader").val();

    if ($("#FromDateHeaderBill").val() != "" && $("#FromDateHeaderBill").val() != undefined)
      this.FromDate = this.GetFormattedDate("FromDateHeaderBill", this.FromDate);

    if ($("#ToDateHeaderBill").val() != "" && $("#ToDateHeaderBill").val() != undefined)
      this.ToDate = this.GetFormattedDate("ToDateHeaderBill", this.ToDate);

    this._appService.GetByFourId(
      "OperationalReport",
      "PaymentSearchReport",
      this.SearchBillNumber == undefined ? "" : this.SearchBillNumber,
      this.SearchReferenceNumber == undefined ? "" : this.SearchReferenceNumber,
      this.FromDate == undefined ? "" : this.FromDate,
      this.ToDate == undefined ? "" : this.ToDate,
    ).subscribe(response => {
      this.PaymentSearchData = response;
      this.ClearData();
    }, err => {
      this.toastr.error("Error occurred while fetching Status data !", 'error');
    });
  }

  SearchPaymentReport() {
    this.GetPaymentReport();
  }

  OnDownloadPaymentSearch() {
    if (this.PaymentSearchData.length > 0) {
      if ($("BillnoSearchHeader").val() != "" && $("#BillnoSearchHeader").val() != undefined)
        this.SearchBillNumber = $("#BillnoSearchHeader").val();

      if ($("#ReferenceNoSearchHeader").val() != "" && $("#ReferenceNoSearchHeader").val() != undefined)
        this.SearchReferenceNumber = $("#ReferenceNoSearchHeader").val();

      if ($("#FromDateHeaderBill").val() != "" && $("#FromDateHeaderBill").val() != undefined)
        this.FromDate = this.GetFormattedDate("FromDateHeaderBill", this.FromDate);

      if ($("#ToDateHeaderBill").val() != "" && $("#ToDateHeaderBill").val() != undefined)
        this.ToDate = this.GetFormattedDate("ToDateHeaderBill", this.ToDate);

      this._appService.GetByFourId(
        "OperationalReport",
        "PaymentSearchReportDownload",
        this.SearchBillNumber == undefined ? "" : this.SearchBillNumber,
        this.SearchReferenceNumber == undefined ? "" : this.SearchReferenceNumber,
        this.FromDate == undefined ? "" : this.FromDate,
        this.ToDate == undefined ? "" : this.ToDate
      ).subscribe(response => {
        this.DownloadPaymentFile(response);
      })
    }
    else {
      this.toastr.error("Data not Avaliable");
    }
  }

  DownloadPaymentFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFilePaymentSearch").attr('href', url);
    $("#DownLoadFilePaymentSearch").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFilePaymentSearch") as HTMLElement;
    element.attributes
    element.click();
    //End 5-Apr-2021
  }

  //End

  //add trupti 16-feb-2022
  tripLocation(bookingId) {
    window.open("/LiveTracking?bookingId=" + bookingId + "&consignmentDetailId=null")
  }
  //end

  // added by vithujan
  printReceipt(ConsignmentNoteId: any, BookingId: any) {
    console.log(ConsignmentNoteId);
    Helpers.setLoading(true);
    HeaderNavComponent.headerNavComponent._appService.GetById("BookingOrigin", "getConsignmentDetailList", ConsignmentNoteId).subscribe((response) => {
      HeaderNavComponent.headerNavComponent.ConsignmentsData = [];
      HeaderNavComponent.headerNavComponent.ConsignmentsData.push(...response as any);
      console.log(response);
      let i = 0;
      HeaderNavComponent.headerNavComponent._appService.GetByTwoId("Booking", "GetDataForLRPrint", BookingId, HeaderNavComponent.headerNavComponent.CompanyId).subscribe((response) => {
        Helpers.setLoading(false);
        HeaderNavComponent.headerNavComponent.ConsignmentsData[0].DriverName = response[0].DriverName;
        HeaderNavComponent.headerNavComponent.ConsignmentsData[0].VehicleType = response[0].VehicleType;
        HeaderNavComponent.headerNavComponent.ConsignmentsData[0].transporterAddress = response[0].transporterAddress;
        HeaderNavComponent.headerNavComponent.ConsignmentsData[0].LicenseNo = response[0].LicenseNo;
        HeaderNavComponent.headerNavComponent.ConsignmentsData[0].TransportName = response[0].TransportName;
        HeaderNavComponent.headerNavComponent.ConsignmentsData[0].eWayBillNo = response[0].eWayBillNo;
        HeaderNavComponent.headerNavComponent.ConsignmentsData[0].eWayBillExpiryDate = response[0].eWayBillExpiryDate;
        HeaderNavComponent.headerNavComponent.ConsignmentsData[0].containerNo = response[0].containerNo;

        //add trupti 01-nov-2021
        if (HeaderNavComponent.headerNavComponent.ConsignmentsData[0].ReferenceNo != null) {
          let printSealNo = HeaderNavComponent.headerNavComponent.ConsignmentsData[0].ReferenceNo.split('/');
          HeaderNavComponent.headerNavComponent.containerNo = printSealNo[0];
          this.containerNo = printSealNo[0];
          if (printSealNo[1]) {
            HeaderNavComponent.headerNavComponent.sealNo = printSealNo[1].split(':')[1];
            this.sealNo = printSealNo[1].split(':')[1];
          }
        }
        //end

        setTimeout(() => {
          HeaderNavComponent.headerNavComponent.ConsignmentsData.forEach(
            (element) => {
              if (
                element.Risk == "Owner" ||
                element.Risk == "owner" ||
                element.Risk == "OWNER"
              ) {
                $("#chkOwn_" + i).attr("checked", true);
              } else {
                $("#chkTransporter_" + i).attr("checked", true);
              }

              if (
                element.Freight == "To Pay" ||
                element.Freight == "to pay" ||
                element.Freight == "To pay" ||
                element.Freight == "TO PAY" ||
                element.Freight == "ToPay"
              ) {
                $("#chkToPay_" + i).attr("checked", true);
              } else {
                $("#chkToBill_" + i).attr("checked", true);
              }

              if (
                element.GST == "Consignor" ||
                element.GST == "consignor" ||
                element.GST == "CONSIGNOR"
              ) {
                $("#chkConsignor_" + i).attr("checked", true);
              } else {
                $("#chkGSTTransporter_" + i).attr("checked", true);
              }

              if (element.Insured) {
                $("#chkInsureYes_" + i).attr("checked", true);
              } else {
                $("#chkInsureNo_" + i).attr("checked", true);
              }

              var TotalQty = 0;
              var TotalWeight = 0;
              var TotalValue = 0;
              element.ProductDetail.forEach((element) => {
                TotalQty = TotalQty + element.Quantity;
                TotalWeight = TotalWeight + element.GrossWeight;
                TotalValue = TotalValue + element.Value;
              });

              element.TotalQty = TotalQty;
              element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
              element.TotalValue = TotalValue;
              i++;
            }
          );
        }, 200);

        setTimeout(() => {
          // kevin 13/03/2020
          var divElements = document.getElementById("ModalConsignmentNote1_2");
          var $iframe = $("<iframe id='frame'>").appendTo("body");
          var printDiv =
            "<style type='text/css' media='print'>@page { size: landscape; }</style><html><head><title> Lorry Receipt </title></head><body>" +
            divElements.innerHTML +
            "</body></html>";
          $iframe.contents().find("body").html(printDiv);
          var win = $iframe[0].contentWindow || $iframe[0];
          $(win.document).ready(function () {
            setTimeout(() => {
              win.window.print();
              setTimeout(() => {
                $iframe.remove();
              }, 500);
            });
          });
          $iframe.contents().find("body").html(printDiv);
        }, 1000);

        // $("#ModalConsignmentNote_2").modal("show");
      });
    });
  }

  GetLoginCompanyData() {
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.SelectedComapnyName = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedComapnyName;
    this.SelectedCompanyAdd = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyAdd;
    this.SelectedCompanyCIN = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyCIN;
    this.SelectedCompantGSTIN = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompantGSTIN;
    this.SelectedCompanyLogo = JSON.parse(localStorage.getItem("ChnageCompnayId")).CompanyLogoPath;
    this.SelectedCompanyPAN = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyPAN;
    this.SelectedCompantEmail = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedComapnyEmail;
    this.SelectedCompanyWebsite = JSON.parse(localStorage.getItem("ChnageCompnayId")).Website;
    //$(".LoginCompanyLogo").attr("src", environment.apiUrl + this.SelectedCompanyLogo);
    this.imgPath = environment.apiUrl + this.SelectedCompanyLogo;
  }

  openTermsandCondition() {
    setTimeout(() => {
      // kevin 13/03/2020
      var divElements = document.getElementById("ModalConsignmentNote_2_Terms");
      var $iframe = $("<iframe id='frame'>").appendTo("body");
      var printDiv =
        "<html><head><title> Terms & Condition </title></head><body>" +
        divElements.innerHTML +
        "</body></html>";
      $iframe.contents().find("body").html(printDiv);
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
    }, 1000);
  }
  // end

  head_trackNumber() {
    this._appService.GetByTwoId("TrackByNo", "trackByNo", this.head_trackid, null).subscribe(response => {
      this.head_trackid = '';
      if (response.length == 0) {
        this.toastr.error("Booking Number Does Not Exist!", "warning");
      } else {
        var bookingId: any;
        bookingId = response[0].Id;
        var condetailsid = null;
        condetailsid = response[0].condetailsid;
        // }
        var url = '/LiveTracking?bookingId=' + bookingId + '&consignmentDetailId=' + condetailsid;
        window.open(url).focus();
      }
    }, err => {
      this.toastr.error("Error occurred while fetching Status data !", 'error');
    });
  }

// added by aditya 02-10-2025 
  // head_trackNumber() {
  //   if (this.hostURL == 'https://gatisaar.ifreightbox.net/') {
  //     const payload = {
  //       bookingNo: this.head_trackid,
  //       userid: this.userId,
  //       CompanyId: this.CompanyId
  //     };

  //     this._appService.Post("Booking", "lt_trackbybookingtripno", payload)
  //       .subscribe(
  //         response => {
  //           // this.head_trackid = '';
  //           if (response.length === 0) {
  //             this.toastr.error("Booking Number Does Not Exist!", "warning");
  //           } else {
  //             const tripInfo = response[0];
  //             const orderNumbers = response.map(x => x.OrderNo);
  //             this.selectedTrip = {
  //               ...tripInfo,
  //               Orders: orderNumbers
  //             };

  //             $("#trip").modal("show");
              
        
  //           }
  //         },
  //         err => this.toastr.error("Error occurred while fetching Status data!", 'error')
  //       );
  //   } else {
  //     this._appService.GetByTwoId("TrackByNo", "trackByNo", this.head_trackid, null)
  //       .subscribe(
  //         response => {
  //           this.head_trackid = '';
  //           if (response.length === 0) {
  //             this.toastr.error("Booking Number Does Not Exist!", "warning");
  //           } else {
  //             const bookingId = response[0].Id;
  //             const condetailsid = response[0].condetailsid;
  //             const url = '/LiveTracking?bookingId=' + bookingId + '&consignmentDetailId=' + condetailsid;
  //             window.open(url, "_blank").focus();
  //           }
  //         },
  //         err => this.toastr.error("Error occurred while fetching Status data!", 'error')
  //       );
  //   }
  // }

  // redirectToTripDocumentPrint() {
  //   console.log('checking');
  //   $("#trip").modal("hide");
  //   this._navService.sendTripNo(this.head_trackid);
  //   if (this.router.url !== '/tripDocumentPrint') {
  //     // localStorage.setItem('TripNo', this.head_trackid);
  //     // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
  //     //   this.router.navigate(['/tripDocumentPrint']);
  //     // });

  //     // setTimeout(() => {
  //     // }, 200);
  //     this.router.navigate(['/tripDocumentPrint']);

  //   } else {
  //     // localStorage.setItem('TripNo', this.head_trackid);
  //     // this.router.navigate(['/tripDocumentPrint']);
  //   }
  // }

  redirectToTripDocumentPrint() {
    $("#trip").modal("hide");
      this._navService.sendTripNo(this.head_trackid);
    const status = this.selectedTrip.CurrentStatus.trim();

    const statusRoutes: { [key: string]: string } = {
      "Pending Vehicle Assign": "/booking",
      "Pending Pickup GateIn": "/mp_GateIn",
      "Pending Pickup LR": "/mp_PendingLR",
      "Pending Pickup GateOut": "/mp_OriginGateOut",
      "EC Origin Pickup": "/ECPickup",
      "Pending Gate In": "/AssignedVehicle",
      "Pending Origin LR": "/GateIn",
      "Pending Origin THC": "/ReadyToDispatch",
      "Pending Origin GetOut": "/eWayBill",
      "Pending Destination GetIn": "/PendingArrival",
      "Pending Destination GetOut": "/DestinationGateIn",
      "Pending Destination Confirm Delivery": "/GateOut",
      "Pending Destination To Close": "/DeliveryConfirmed",
      "Completed": "/BookingCompleted"
    };

    const route = statusRoutes[status || ""];
    if (route) {
      this.router.navigate([route], {
        queryParams: { tripNo: this.selectedTrip.BookingNo }
      });
      $("#trip").modal("hide"); // close modal
    } else {
      console.warn("No route mapping found for status:", status);
      this.toastr.warning(`No page defined for status: ${status}`);
    }
  }

  

  closeModal(modal: any) {
    $("#trip").modal("hide");
  }

  openLiveTracking(trip: any) {
    if (!trip) return;

    const bookingId = trip.BookingId;
    const condetailsid = trip.ConsingmentDetailsId; 

    if (!bookingId || !condetailsid) {
      this.toastr.warning('Cannot open live tracking. Missing data.');
      return;
    }

    const url = `/LiveTracking?bookingId=${bookingId}&consignmentDetailId=${condetailsid}`;
    window.open(url, "_blank").focus();
  }

//end

  clickUserProfile() {
    this.UserEmailId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("EmailId")));
    this.EmailId = this.UserEmailId;
    this.UserFullName = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserFullName")));
    this.userComanyName = JSON.parse(localStorage.getItem("userComanyName"));
    let x = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SetUserRole")));
    var userRole1 = x;
    this.userRole = $.parseJSON(userRole1);

  }

  closeAddModal() {
    this.showModal = false;
  }
}




